<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body,html {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@font-face {
  font-family: Heavy;
  src: url('./assets/SourceHanSansCN-Heavy.ttf');
}

@font-face {
  font-family: Regular;
  src: url('./assets/SourceHanSansCN-Regular.ttf');
}

@font-face {
  font-family: DINCond;
  src: url('./assets/DINCond-Black.ttf');
}

.english {
  font-family: DINCond;
}

.clear:after{display:block;clear:both;content:"";visibility:hidden;height:0}
.clear{zoom:1}

.ago {
  position: absolute;
  top: -20px;
  right: 10px;
}

.after {
  position: absolute;
  top: 20px;
  right: 10px;
}

.link_to:hover {
  cursor: pointer;
}

.pa-item {
  width: 2px;
  height: 20px;
  margin-bottom: 5px;
  background: #FFFB00;
  transition: all .5s;
}

.pa-item:hover {
  cursor: pointer;
}

.pa-item-active {
  height: 100px;
}

.phone_home_main .swiper-pagination-bullet {
	background-color: #FFFB00;
	display: inline-block;
	width: .6rem;
	height: .15rem;
	border-radius: 0!important;
	transition:  all 1s ease;
	opacity: 1;
}

.phone_home_main .swiper-pagination-bullet-active {
	background-color: #FFFB00;
	display: inline-block;
	width: 6rem;
	height: .15rem;
	border-radius: 0!important;
	transition:  all 1s ease;
}

.phone_home_main .swiper-pagination {
	bottom: 6rem;
}

.swiper-pagination_1 {
	position: absolute;
	right: 10%;
	top: 80%;
	color: #FFFB00;
}
.vjs-modal-dialog-content{
  display: none!important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue